import React, { useState } from 'react';

function normalizeSectionTitle(title) {
  return String(title || '').replace(/^\s{0,3}#{1,6}\s*/, '').trim();
}

function FAQSection({ title, items }) {
  const [openId, setOpenId] = useState(items[0]?.id || '');

  return (
    <section className="career-faq" aria-labelledby="career-faq-title">
      <div className="wrap">
        <div className="career-faq__head head-block">
          <p className="eyebrow">Need Clarity?</p>
          <h2 id="career-faq-title" className="section-title">{normalizeSectionTitle(title)}</h2>
          <p className="section-sub">Quick answers to the most common membership questions so you can decide with confidence.</p>
        </div>
        <div className="career-faq__list">
          {items.map((item) => {
            const isOpen = openId === item.id;
            const panelId = `career-faq-panel-${item.id}`;
            const buttonId = `career-faq-button-${item.id}`;

            return (
              <article key={item.id} className={`career-faq__item ${isOpen ? 'is-open' : ''}`}>
                <button
                  id={buttonId}
                  type="button"
                  className="career-faq__question"
                  onClick={() => setOpenId(isOpen ? '' : item.id)}
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                >
                  <span>{item.question}</span>
                  <span className="career-faq__icon" aria-hidden="true">{isOpen ? '−' : '+'}</span>
                </button>
                {isOpen ? (
                  <div
                    id={panelId}
                    className="career-faq__panel"
                    role="region"
                    aria-labelledby={buttonId}
                  >
                    <p className="career-faq__answer">{item.answer}</p>
                  </div>
                ) : null}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FAQSection;